import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-shield",
  "use": "icon-shield-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-shield\">\r\n<defs>\r\n<style type=\"text/css\"></style>\r\n</defs>\r\n<path d=\"M916.48 242.88l-8.96-70.72L512 32 116.48 172.16l-8.96 70.4c-3.2 23.68-68.48 578.88 365.12 736L512 992l39.04-14.08C983.36 822.4 919.68 266.56 916.48 242.88zM512 160l278.4 102.72c6.4 64 41.6 471.36-278.4 587.52z\" p-id=\"8762\">\r\n</path></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/shield.svg
// module id = /n+E
// module chunks = 16